export default __webpack_public_path__ + "static/media/clipart722174.8eb2ac18.png";